import { FieldValues } from 'react-hook-form';
import Environment from '../lib/Environment';
import XhrRequestHandler, { StatusResponseJSON } from '../lib/XhrRequestHandler';
import { Collaborator } from './collaborators/Collaborator';
import CollaboratorSystem, { ICollaborator } from './collaborators/CollaboratorSystem';
import { SystemDateParser } from './SystemDateParser';
import { User } from './User';
import { UserProfile } from './UserProfile';
import gererateUuid from '../common/uuid';
import { IList_cnih } from '../Components/Collaborator/CollaboratorView/updateCollaborator/InformacionGeneral';
import {  IstructuraUseform } from '../Components/Collaborator/CollaboratorView/updateCollaborator/interface';
import { ILisCargo, IOrganizationNode } from '../Components/Collaborator/List/collaboratorCreate';
import { IComboBoxOption } from '@fluentui/react';

export interface IUserProfile {
  per_id: string;
  per_nombre: string;
  per_nemotecnico: string;
}

export interface IorganizationLevels{
  nio_id: string,
  nio_nombre: string,
  nio_nombre_tec:string
}

export interface IQRurl {
  qrUrl: string;
}

export interface ILoggedUser extends IUser {
  representing: ICollaborator;
  perfil: IUserProfile;
}

export interface IUser {
  colaborador:        IUserColaborador;
  us_id:              string;
  us_nombre:          string;
  us_email:           string;
  us_activo:          boolean;
  us_bloqueado:       boolean;
  us_bloqueado_desde: null;
  us_perid:           string;
  us_requiere_totp:   boolean;
  us_trad_id:         string;
  language:           IUserLanguage;
}

export interface IUserColaborador {
  cargoColaborador:         null;
  col_id:                   string;
  col_nombre:               string;
  col_apellido:             string;
  col_documento_numero:     string;
  col_tipo_documento:       null;
  col_email:                string;
  col_telefono_movil:       null;
  col_imagen_url:           null;
  col_iniciales:            string;
  col_fecha_nacimiento:     string;
  col_activo:               boolean;
  col_id_sap:               string;
  col_fecha_alta:           string;
  col_fecha_baja:           null;
  col_baja_motivo:          string;
  col_actividad_facturable: boolean;
  col_empp_id:              string;
}

export interface IUserLanguage {
  trad_id:          string;
  trad_nombre:      string;
  trad_activo:      boolean;
  trad_nombre_full: string;
}


export interface ILanguage {
  trad_id: string;
  trad_nombre: string;
  trad_activo: boolean;
  trad_nombre_full: string;
}

export interface IlistCollaboratorForJefatura {
    active: boolean
    birthDay: string
    email: string
    id: string
    initials: string
    lastName: string
    name: string
    cargoColaborador: {
      carcol_activo: boolean
      carcol_cargoid: string
      carcol_colid: string
      carcol_es_actual: boolean
      carcol_fecha_desde: string
      carcol_fecha_hasta: string
      carcol_id: string
      carcol_norid: string
      cargo: {
        cargo_activo: boolean
        cargo_id: string
        cargo_nombre: string
      }
    }
  }
export interface CarcolNodo {
  carcol_id: string;
  carcol_colid: string;
  carcol_cargoid: string;
  carcol_fecha_desde: string;
  carcol_fecha_hasta: string | null;
  carcol_activo: string;
  carcol_norid: string;
  carcol_temp: string | null;
  carcol_es_actual: string;
  nodo_organigrama: NodoOrganigrama[];
  cargo: Cargo;
}

export interface NodoOrganigrama {
  nor_id: number;
  nor_nivel: number;
  nor_nombre: string;
  nivel_nombre: string;
  nivel_nombre_tec: string;
}

export interface Cargo {
  cargo_id: string;
  cargo_nombre: string;
  cargo_activo: string;
}

class AuthenticationSystem {
  private readonly loginBase = '/loginDVM';
  private readonly colaboradores = '/colaboradores';
  private loggedUser: User | undefined;

  constructor(
      private requestHandler: XhrRequestHandler,
      private environment: Environment,
      private dateParser: SystemDateParser,
      private collaboratorsSystem: CollaboratorSystem
  ) {
    this.loggedUser = undefined;
  }

  async loggedInUser(): Promise<User> {
    const data = await this.requestHandler.get<ILoggedUser>(
        `${this.loginBase}/isLoggedIn?tz=${encodeURIComponent(this.dateParser.getUserTimezone())}`
    );

    this.loggedUser = this.userFromILoggedUser(data);

    return this.loggedUser;
  }

  async checkEmail(email:string, token:string) {
    this.requestHandler.clearCache();
    const response = await this.requestHandler.post<StatusResponseJSON<any>>(`${this.loginBase}/check-email`,{email, token});
    return new StatusResponse(response.statusCode, response.data as IQRurl | null);
  }

//creado para formulario agregar colaboradores 
  async createUser(data:FieldValues,id:string):Promise<any> {
    const datos = {
			data,
			uuid:id
		}
    const result = this.requestHandler.post(`${this.colaboradores}/createUser`,datos)
		return result;
}
 
 async getSelects(nor_nivel?: string,nor_padre?:string): Promise<IOrganizationNode[]>{
  let url = this.colaboradores +'/search_organigrama';
  if (nor_nivel && nor_padre) {
    url += `?nor_padre=${nor_padre}&nor_nivel=${nor_nivel}`;
  } else if (nor_nivel) {
    url += `?nor_nivel=${nor_nivel}`;
  } else if (nor_padre) {
    url += `?nor_padre=${nor_padre}`;
  }

  const result = this.requestHandler.get<IOrganizationNode[]>(url);

   return result;
 }

 async lisCargo():Promise<ILisCargo[]>{
  const data =  await this.requestHandler.get<ILisCargo[]>(`${this.colaboradores}/list_cargo`);
  return data;
 }

 async listCargoTypeComboBoxOptions():Promise<IComboBoxOption[]>{

  const data =  await this.requestHandler.get<ILisCargo[]>(`${this.colaboradores}/list_cargo`);
  const result:IComboBoxOption[] = data.map(c=>{
    const valor:IComboBoxOption = {
     key:c.cargo_id,
     text:c.cargo_nombre
    }
   return valor 
 })
  return result;
 }

//creado para formulario agregar colaboradores 
  async signIn(
      email: string,
      password: string,
      token: string
  ): Promise<StatusResponse<User | IQRurl | null>> {
    try {
    const credentials = {
      email,
      password,
      token,
    };
    this.requestHandler.clearCache();
    const response = await this.requestHandler.post<StatusResponseJSON<ILoggedUser | IQRurl | null>>(
        `${this.loginBase}/loginWithCredentials`,
        credentials
    );

    if (response.statusCode === 200) {
      this.loggedUser = this.userFromILoggedUser(response.data as ILoggedUser);
      return new StatusResponse(response.statusCode, this.userFromILoggedUser(response.data as ILoggedUser));
    }

    return new StatusResponse(response.statusCode, response.data as IQRurl | null);
    } catch (error : any) {
      return new StatusResponse(400,null,error);
    }

  }

  async getOrganizationLevels(){
    const data = await this.requestHandler.get<IorganizationLevels[]>('/organigrama/levels');
    return data ;
  } 

  async validateCode2FA(code) {
    const data = await this.requestHandler.post<ILoggedUser>(`${this.loginBase}/validate-totp-code`, {
      code: code,
    });
    return this.userFromILoggedUser(data);
  }

  async updateColaboratorUser(datos){

    const data = {
      data :datos,
      uuid:gererateUuid()
    }
     const result = await this.requestHandler.post(`${this.colaboradores}/UpdateCollaborador`,data);
     return result
  }

  async getListProyectoEnlace(email:string): Promise<any>{
     
    const result = await this.requestHandler.get<any>(`${this.colaboradores}/proyecto_enlace/${email}`);
    return result.List_cnih;
  }

  async DeleteUNProyectoEnlace(id:string):Promise<any>{
    const datos = {
      uuid:gererateUuid()
    }
    const result = this.requestHandler.post(`${this.colaboradores}/delete_cnih/${id}`,datos);
     return result;
  }


  async modificarOneProyectoEnlace(datos:IList_cnih):Promise<any>{
    const datosProyecto = {
      data: {
        activo:datos.cnih_activo,
        id: datos.cnih_id,
        participacion: datos.cnih_porcentaje_excento,
        vigencia: datos.cnih_fecha_alta,
        fechafin:datos.cnih_fecha_baja
      },
      uuid:gererateUuid()
    }
    const result = this.requestHandler.post(`${this.colaboradores}/update/cnih`,datosProyecto);
    return result;
  }

  async CrearOneProyectoEnlace(datos:IList_cnih,email:string):Promise<any>{
    const datosProyecto = {
      data: {
        email: email,
        participacion: datos.cnih_porcentaje_excento,
        vigencia: datos.cnih_fecha_alta,
        fechafin:datos.cnih_fecha_baja
      },
      uuid:gererateUuid()
    }
    const result = this.requestHandler.post(`${this.colaboradores}/create/cnih`,datosProyecto);
    return result;
  }

  async CreateEstructuraOranizacional(datos:IstructuraUseform):Promise<any>{
    const datosRegular = {
      data:datos,
      uuid:gererateUuid()
    };

    const result = this.requestHandler.post(`${this.colaboradores}/create/estructura_oraganizacional`,datosRegular);
    return result;
  }

  async UpdateEstructuraOranizacional(datos:IstructuraUseform):Promise<any>{
    if(datos.carcol_id === undefined)return;
    const datosRegular = {
      data:datos,
      uuid:gererateUuid()
    };
    
    const result = this.requestHandler.put(`${this.colaboradores}/estructura_oraganizacional/update`,datosRegular);
   return result;
  }

  async ListEstructuraOrganizacional(id: string): Promise<CarcolNodo[]> {
    if (!id) return [];
    const datosRegular = { uuid: gererateUuid() };
    const result = await this.requestHandler.post<any>(
      `${this.colaboradores}/estructura_oraganizacional/${id}`,
      datosRegular
    );
    return result.data;
  }

  async DeleteEstructuraOrganizacional(id:string):Promise<any>{
    const datosRegular = {uuid:gererateUuid()};
    const result = this.requestHandler.post(`${this.colaboradores}/deleteE/estructura_oraganizacional/${id}`,datosRegular);
    return result;
  }

  corporateSingIn() {
    this.requestHandler.clearCache();
    this.requestHandler.navigateTo(this.environment.corporateSignInUrl());
  }

  signOut(returnTo: string) {
    this.requestHandler.clearCache();
    this.requestHandler.navigateTo(`${this.loginBase}/logout?returnTo=${returnTo}`);
  }

  menuService(){
    return this.requestHandler.simpleGetWithCache(`${this.colaboradores}/menu-controller`);
   }

  getListCollaboratorForJefatura(norid:string){
    return this.requestHandler.get<IlistCollaboratorForJefatura[]>(`/colaboradores/list-collaborator-for-jefatura/${norid}`);
   }

  private userFromILoggedUser({ representing, perfil, ...user }: ILoggedUser) {
    const collaborator = Collaborator.fromICollaborator(this.collaboratorsSystem, representing);
    const profile = UserProfile.fromIUserProfile(perfil);

    return User.fromIUser(collaborator, profile, user);
  }
}

class StatusResponse<T> {
  constructor(
    private statusCode: number,
    private data: T,
    private message?: string 
  ) {}

  getStatusCode() {
    return this.statusCode;
  }

  getData() {
    return this.data;
  }

  getMessage() {
    return this.message;
  }

  requireTOTPCode() {
    return this.statusCode === 204;
  }

  shouldShowQRAuth() {
    return this.statusCode === 205;
  }

  isOk() {
    return this.statusCode === 200;
  }
}

export default AuthenticationSystem;
